import React from "react";
import { connect } from "react-redux";
import { ProgressBar } from "react-bootstrap";
import NavBar from "./common/NavBar";
import "../stylesheets/main.css";
import { Spinner, SpinnerSize, PrimaryButton } from 'office-ui-fabric-react';
import {browserHistory} from 'react-router';
import { token } from "../axios/auth";
import axios from 'axios';
import config from '../config';

// App component
export class App extends React.Component {

  componentDidMount() {
    if (!this.props.auth.tryGetToken) {
      this.props.dispatch(token());
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.auth.tryGetToken && !newProps.auth.user) {
      if (window.location.pathname != '/' &&
        window.location.pathname != '/login' &&
        window.location.pathname != '/active-email' &&
        window.location.pathname != '/active-vendor' /*&&
        window.location.pathname != '/active-clinic' &&
        window.location.pathname != '/active-driver'*/) {
        window.location.href = '/login';
        // browserHistory.push('/login');
      }
    }
  }
  breakOut() {
    axios.post(config.apiUrl + '/auth/traking', {
      type: 'break-out'
    })
    .then(() => {
        delete localStorage.breakin;
        window.location.reload();
    });
  }

  // render
  render() {
    // show the loading state while we wait for the app to load
    const {children} = this.props;
    var pathname = window.location.pathname;
    var breakin = localStorage.breakin || '0';
    breakin = parseInt(breakin);
    var timeNow = new Date().getTime();
    if (timeNow - breakin > 8 * 60 * 60 * 1000) {
      delete localStorage.breakin
    }
    else {
      return <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <PrimaryButton onClick={() => this.breakOut()}>Break out</PrimaryButton>
      </div>
    }
    // render
    return (
      !this.props.auth.tryGetToken ?
      <Spinner size={SpinnerSize.large} /> :
      (pathname == '/'  || pathname == '/login' || pathname == '/active-email' || pathname== '/active-vendor' || pathname== '/active-clinic' || pathname== '/active-driver' || (this.props.auth && this.props.auth.user) ?
        <div>
          <div>
            {this.props.auth.user &&
              <NavBar/>
            }
          </div>
          <div>
            {children}
          </div>
        </div>
        : <div>404</div>
      )
    );
  }
}

// export the connected class
function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}
export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./client/components/App.js